import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.history.cash_register_reports",
    url: "/fechamento-de-caixas",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        name: "Histórico de Caixas",
        priority: 500,
        state: "app.history.cash_register_reports"
      },
      authorization: context =>
        context.user.permissions.includes("view_cash_register_reports")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/cash-register-reports/index.js